import React, { useState } from 'react';
import './app.css';
import '../demo.css';
import pages from '../pages';

interface PageItem {
  title: string;
  page: React.ComponentType;
  url: string;
}

interface Section {
  title: string;
  pages: PageItem[];
}

const App: React.FC = () => {
	const [navOpen, setNavOpen] = useState(true);
	const [selectedPage, setSelectedPage] = useState<PageItem>(pages[0].pages[0]);

	const toggleNav = () => {
		setNavOpen(!navOpen);
	};

	const openCode = () => {
		const url = selectedPage.url;
		window.open(url, 'none');
	};

	const renderMenu = () => {
		return pages.map((section: Section) => {
			return (
				<div className="menu-section" key={section.title}>
					<h4>{section.title}</h4>
					<ul>
						{section.pages.map((page: PageItem) => {
							return (
								<li className={`${selectedPage === page ? 'selected' : ''}`} key={page.title} onClick={() => { setSelectedPage(page); }}>{page.title}</li>
							);
						})}
					</ul>
				</div>
			);
		});
	};

	const Page = selectedPage.page;
	return (
		<div className="app">
			<div className={`nav-button ${navOpen ? 'open' : ''}`} onClick={toggleNav}>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
			</div>
			<div className={`navigator ${navOpen ? '' : 'closed'}`}>
				<div className="navigator-content">
					<div className="navigator-header">
						<h3>@mekanysmos/react-smooth-dnd</h3>
						<div className="divider"></div>
					</div>
					<div>
						{renderMenu()}
					</div>
				</div>
			</div>
			<div className="content">
				<div className={`header ${navOpen ? 'open' : ''}`}>
					{selectedPage.title}
					<div className="source-code" onClick={openCode}>
						<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZml0PSIiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIGZvY3VzYWJsZT0iZmFsc2UiPgogICAgPHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgyNHYyNEgwVjB6Ij48L3BhdGg+CiAgICA8cGF0aCBkPSJNOS40IDE2LjZMNC44IDEybDQuNi00LjZMOCA2bC02IDYgNiA2IDEuNC0xLjR6bTUuMiAwbDQuNi00LjYtNC42LTQuNkwxNiA2bDYgNi02IDYtMS40LTEuNHoiIGZpbGw9IiNGRkYiPjwvcGF0aD4KPC9zdmc+Cg==" alt="" />
						<span>source</span>
					</div>
				</div>
				<div className="demo">
					<Page />
				</div>
			</div>
		</div>
	);
};

export default App;
